import React from 'react';
import styled, { css } from 'styled-components';
import CopyTextBlock from '~/components/molecule/CopyTextBlock';
import useCurrentAccount from '~/hooks/useCurrentAccount';
import { isProduction } from '~/util';
import { MASTER_ACCOUNT_ID } from '~/util/constants';
import { Label } from '../Typography';
import Icon from '../Icon';
import JustificationContainer from '../JustificationContainer';

const text = {
  isMasterAccount: 'Master account',
};

const AccountIdBadge = () => {
  const currentAccount = useCurrentAccount();

  const isDev = isProduction() !== true;
  if (!isDev) return null;

  return (
    <Container>
      {currentAccount.id === MASTER_ACCOUNT_ID && (
        <JustificationContainer gap="xxxs">
          <Icon color={{ group: 'info' }} name="info" />{' '}
          <Label color={{ group: 'info' }}>{text.isMasterAccount}</Label>
        </JustificationContainer>
      )}
      <CopyTextBlock label="Account ID" textToCopy={currentAccount.id} />
    </Container>
  );
};

const Container = styled.div(
  ({ theme }) => css`
    position: absolute;
    top: ${theme.space('xl')};
    right: ${theme.space('xl')};
    z-index: ${theme.z('top')} + 100;
    pointer-events: all;
  `,
);

export default AccountIdBadge;
